import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import style from "./style.module.scss";
export default function DashboardLayout(props) {
    return (_jsx("div", { className: classNames(style["dashboard-layout"], {
            [style[`dashboard-layout--${props.cols}-cols`]]: props.cols,
        }), children: props.children }));
}
